// extracted by mini-css-extract-plugin
export default {"main":"qecKfSyPHyl9v4yxJGLl","footer":"NVoe6f8ApCBGM1MJ1mzf"};